/**
 * TODO: duplicated from '@worldcoo/monolith/core' because of an issue with Nextjs:
 * https://github.com/vercel/next.js/issues/75840
 * https://github.com/vercel/next.js/issues/74816
 */
export const languages = {
	Spanish: 'SPA',
	English: 'ENG',
	Catalan: 'CAT',
	Euskera: 'EUS',
	Gallego: 'GLG',
	German: 'GER',
	French: 'FRE',
	Korean: 'KOR',
	Chinese: 'CHI',
	Japanese: 'JPN',
	Portuguese: 'POR',
	Russian: 'RUS',
	Italian: 'ITA',
	Dutch: 'DUT',
	Greek: 'GRE',
} as const;

export type Language = (typeof languages)[keyof typeof languages];
